<template>
  <div v-loading="loading" style="width:100%;height:100%;overflow-x:hidden;overflow-y:auto;background:#f6f6f6;padding:10px">
    <!-- 时间选择 -->
    <div class="card" style="margin-bottom:10px">
      <div style="display:flex;align-items:center;gap:10px">
        <div style="width:320px;flex-shrink:0">
          <el-date-picker v-model="dateRange" type="monthrange" start-placeholder="开始月份" end-placeholder="结束月份" value-format="YYYY-MM-DD" style="width:100%" />
        </div>
        <el-button type="primary" @click="onLoad">查询</el-button>
      </div>
    </div>

    <!-- 汇总卡片 -->
    <div style="display:flex;gap:10px;margin-bottom:10px">
      <div class="card" style="flex:1;text-align:center">
        <div style="font-size:12px;color:#999">总收入</div>
        <div style="font-size:22px;font-weight:600;color:#67c23a;margin-top:6px">{{ data.totalRevenue }}<text style="font-size:12px">￥</text></div>
        <div style="font-size:11px;color:#bbb;margin-top:4px">含商品手续费 {{ data.spSxf }}￥ / 分销返佣 {{ data.spFx }}￥</div>
      </div>
      <div class="card" style="flex:1;text-align:center">
        <div style="font-size:12px;color:#999">总成本</div>
        <div style="font-size:22px;font-weight:600;color:#f56c6c;margin-top:6px">{{ data.totalCost }}<text style="font-size:12px">￥</text></div>
      </div>
      <div class="card" style="flex:1;text-align:center">
        <div style="font-size:12px;color:#999">总利润</div>
        <div :style="{fontSize:'22px',fontWeight:600,marginTop:'6px',color: Number(data.totalProfit)>=0?'#67c23a':'#f56c6c'}">{{ data.totalProfit }}<text style="font-size:12px">￥</text></div>
        <div style="font-size:11px;color:#bbb;margin-top:4px">已扣除商品手续费与分销返佣</div>
      </div>
      <div class="card" style="flex:1;text-align:center">
        <div style="font-size:12px;color:#999">利润率</div>
        <div style="font-size:22px;font-weight:600;color:#409eff;margin-top:6px">{{ data.profitRate }}%</div>
      </div>
    </div>

    <!-- 分类利润 -->
    <div style="display:flex;gap:10px;min-width:0">
      <!-- 商品按品类 -->
      <div class="card" style="flex:1;min-width:0">
        <div style="font-size:14px;font-weight:600;margin-bottom:10px">
          商品利润（收入 {{ data.spRevenue }}￥ / 成本 {{ data.spCost }}￥ / 手续费 {{ data.spSxf }}￥ / 分销返佣 {{ data.spFx }}￥ / 利润 <span :style="{color: Number(data.spProfit)>=0?'#67c23a':'#f56c6c'}">{{ data.spProfit }}￥</span>）
        </div>
        <el-table :data="data.spByCategory" size="small" stripe style="width:100%">
          <el-table-column label="品类" prop="Category" min-width="100">
            <template #default="{ row }">
              <el-link type="primary" @click="goSpDetail(row.Category)">{{ row.Category }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="收入" prop="Revenue" align="right" width="100">
            <template #default="{ row }">
              <el-link type="primary" @click="goSpDetail(row.Category)">{{ row.Revenue }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="成本" prop="Cost" align="right" width="100" />
          <el-table-column label="费用(手续费+分销)" prop="Fee" align="right" width="140" />
          <el-table-column label="利润" prop="Profit" align="right" width="100">
            <template #default="{ row }">
              <el-link type="primary" @click="goSpDetail(row.Category)">
                <span :style="{color: Number(row.Profit)>=0?'#67c23a':'#f56c6c'}">{{ row.Profit }}</span>
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="Count" align="right" width="70" />
        </el-table>
      </div>
      <!-- 旅游按销售员 -->
      <div class="card" style="flex:1;min-width:0">
        <div style="font-size:14px;font-weight:600;margin-bottom:10px">
          旅游利润（收入 {{ data.lyRevenue }}￥ / 成本 {{ data.lyCost }}￥ / 利润 <span :style="{color: Number(data.lyProfit)>=0?'#67c23a':'#f56c6c'}">{{ data.lyProfit }}￥</span>）
        </div>
        <el-table :data="data.lyBySales" size="small" stripe style="width:100%">
          <el-table-column label="销售员" prop="XsyXm" min-width="100" />
          <el-table-column label="收入" prop="Revenue" align="right" width="100" />
          <el-table-column label="成本" prop="Cost" align="right" width="100" />
          <el-table-column label="利润" prop="Profit" align="right" width="100">
            <template #default="{ row }">
              <span :style="{color: Number(row.Profit)>=0?'#67c23a':'#f56c6c'}">{{ row.Profit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单数" prop="Orders" align="right" width="80" />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { caiwu_lirun } from "@/http/api";
import store from "@/store";
import dayjs from "dayjs";

export default {
  setup() {
    const loading = ref(false);
    const now = dayjs();
    const dateRange = ref([now.startOf("month").format("YYYY-MM-DD"), now.endOf("month").format("YYYY-MM-DD")]);
    const data = reactive({
      totalRevenue: "0", totalCost: "0", totalProfit: "0", profitRate: "0",
      spRevenue: "0", spCost: "0", spSxf: "0", spFx: "0", spProfit: "0", spByCategory: [],
      lyRevenue: "0", lyCost: "0", lyProfit: "0", lyBySales: [],
    });

    // 穿透到商品订单明细（按品类+时间范围）
    const goSpDetail = (category) => {
      const params = {};
      if (dateRange.value && dateRange.value.length === 2) {
        params.startDate = dateRange.value[0];
        params.endDate = dateRange.value[1];
      }
      if (category) {
        params.category = category;
      }
      store.commit('openMenu', {
        path: 'CaiWuSpddMingXi',
        title: '商品订单明细',
        data: params,
        refresh: true,
      });
    };

    const onLoad = () => {
      loading.value = true;
      const params = {};
      if (dateRange.value && dateRange.value.length === 2) {
        params.startDate = dateRange.value[0];
        params.endDate = dateRange.value[1];
      }
      caiwu_lirun(params).then(res => {
        if (res.status == 200) Object.assign(data, res.data);
      }).finally(() => { loading.value = false; });
    };

    onMounted(() => onLoad());

    return { loading, dateRange, data, onLoad, goSpDetail };
  },
};
</script>

<style scoped>
.card { background:#fff;border-radius:7px;padding:20px; }
</style>
